import { Component, View, OnInit } from 'angular2/core';
import { CORE_DIRECTIVES, DatePipe } from 'angular2/common';
import { Router, RouteParams } from 'angular2/router';

import { Header } from '../layout/header/header';
import { Sidebar } from '../layout/sidebar/sidebar';
import { Company } from './company.model';
import { CompanyService } from './company.service';
import { AlertService, AlertMessage, MessageType } from '../alert/alert.service';

let template = require('./company-detail.html');

@Component({
  selector: 'company-detail'
})
@View({
  pipes: [DatePipe],
  directives: [CORE_DIRECTIVES, Header, Sidebar],
  template: template,
})
export class CompanyDetail implements OnInit {

  title: string;
  company: Company;

  constructor(
    public router: Router,
    public routeParams: RouteParams,
    private companyService: CompanyService,
    private alertService: AlertService
    ) { }

  ngOnInit() {
    this.company = new Company();
    let id = this.routeParams.get('id');
    if (id) {
      this.title = 'Editar asociado';
      this.loadCompany(id);
    } else {
      this.title = 'Crear asociado';
    }
  }

  save($event, company: Company) {
    this.companyService.save(company).subscribe(
      response => {
        let savedCompany = response.json();
        this.alert('Asociado guardado con éxito', MessageType.Success);
        this.router.navigate(['CompanyDetail', { id: savedCompany.id }]);
      },
      error => {
        this.alert('Error al guardar el asociado', MessageType.Danger);
      }
      );
  }

  cancel($event) {
    $event.preventDefault();
    this.router.navigate(['CompanyList']);
  }

  loadCompany(id: string) {
    this.companyService.get(id).subscribe(
      response => {
        this.company = new Company().fromJson(response.json());
      },
      error => {
        this.alert('Error al recuperar los datos del asociado', MessageType.Danger);
      }
      );
  }

  alert(text: string, type: MessageType) {
    this.alertService.push({ text, type });
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/company/company-detail.ts
 **/